/*
 * Filename: application/frontend/src/authConfig.template.js
 * Description: authentication configuration template
 * Author: Aires Marques
 * History:
 + 2023-11-23 - documented
 * Notes:
*/

export const msalConfig = {
    auth: {
      clientId: "",
      authority: "https://login.microsoftonline.com/c567fe94-f430-4773-9330-9dc2f3334913",
      redirectUri: "https://jolly-glacier-02d9f7803.5.azurestaticapps.net"
      // For Local development - uncomment the line below and comment the line above
      // redirectUri: "http://localhost:3000"
    },
    cache: {
      // This configures where the cache will be stored
      cacheLocation: "sessionStorage", 
      
      // Set this to "true" if having issues on IE11 or Edge
      storeAuthStateInCookie: false, 
    }
};
  
// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"]
};


// Reading from environment variables
const REACT_APP_BACKEND_URL = `https://real-estate-unit-rentals.azurewebsites.net/api/`;


export const backend = {
  url: REACT_APP_BACKEND_URL,
  ping: REACT_APP_BACKEND_URL + "ping?details=1",
  
  // function POST form submission
  url_submit_form_contract: REACT_APP_BACKEND_URL + "submit_form_contract",
  ping_submit_form_contract: REACT_APP_BACKEND_URL + "submit_form_contract?ping=1",
  
  // function POST payrequest ping
  url_post_payrequest: REACT_APP_BACKEND_URL + "v2/payrequest/mbway",
  ping_post_payrequest: REACT_APP_BACKEND_URL + "v2/payrequest/mbway?ping=1",

  // function GET payrequest ping
  url_get_payrequest: REACT_APP_BACKEND_URL + "v2/payrequest/mbway",
  ping_get_payrequest: REACT_APP_BACKEND_URL + "v2/payrequest/mbway?ping=1",
};


export const app_location_data = {
  url: "https://realestatestoreacc.blob.core.windows.net/public-configuration/location_data.json",
};
